<template>
  <div class="listing">
    <loader class="imageLoader" :loading="loading" />
    <header class="header">
      <div class="header__Search">
        <form @submit.prevent="filter({ search_query: filters.search_query })" class="search">
          <input
            class="search__Text"
            type="search"
            :placeholder="$store.getters.getStringTranslation('enterFileName')"
            v-model="filters.search_query"
          />
          <button class="search__Button">
            <icon name="search"></icon>
          </button>
        </form>
      </div>
    </header>
    <section class="page">
      <header class="pageHeader">
        <div class="pageHeader__Inner">
          <h1 class="pageHeader__Title">{{ $store.getters.getStringTranslation('mediaUploads') }}</h1>
        </div>
      </header>

      <div class="tab">
        <div class="tab__MenuWrapper">
          <!-- <nav class="tab__Menu">
            <ul class="tab__MenuList">
              <li>
                <a @click="photoLibrary = false">Uploaded files</a>
              </li>
              <li>
                <a @click="photoLibrary = true">Photo library</a>
              </li>
            </ul>
          </nav> -->

          <nav class="tab__Menu">
            <ul class="tab__MenuList" v-if="filterable">
              <li>
                <a :class="{ 'is-Active': searchParams.types.length === 0 }" @click="filter({ types: [] })">All</a>
              </li>
              <li v-for="item in filters.types" :key="item.id">
                <a
                  :class="{ 'is-Active': searchParams.types[0] === item.toLowerCase() }"
                  @click="filter({ types: [item.toLowerCase()] })"
                  >{{ item }}</a
                >
              </li>
            </ul>

            <ul class="tab__MenuList--Right">
              <li v-for="item in filters.order_by" :key="item.id">
                <a
                  :class="{
                    'is-Active': item.toLowerCase() === searchParams.order_by.toLowerCase(),
                  }"
                  @click="filter({ order_by: item.toLowerCase() })"
                  >{{ $store.getters.getStringTranslation(item.toLowerCase()) }}</a
                >
              </li>
              <li v-for="item in filters.order_dir" :key="item.id">
                <a
                  :class="{
                    'is-Active': item.toLowerCase() === searchParams.order_dir.toLowerCase(),
                  }"
                  @click="filter({ order_dir: item.toLowerCase() })"
                  >{{ $store.getters.getStringTranslation(item.toLowerCase()) }}</a
                >
              </li>
            </ul>
          </nav>
        </div>

        <div class="formSection__Row">
          <p>
            <label class="formLabel" for="file">{{ $store.getters.getStringTranslation('file') }}</label>
          </p>
          <div class="formUpload--Standalone">
            <input class="formUpload__Input" type="file" name id="file" @change="handleChange" />
            <label for="file" class="formUpload__Label">
              <template v-if="file.name === undefined">
                <span>{{ $store.getters.getStringTranslation('dragAndDrop') }}</span>
                <strong>{{ $store.getters.getStringTranslation('chooseFileToUpload') }}</strong>
              </template>
              <template v-else>{{ file.name }}</template>
            </label>
          </div>

          <div class="crop" v-if="crop">
            <button @click="crop = false" class="crop__Overlay"></button>
            <div class="crop__Inner">
              <clipper-basic ref="clipper" v-model="clip" crossOrigin="Anonymous" :src="image"></clipper-basic>

              <div class="crop__Buttons">
                <button type="button" @click="generateImage" class="button">Save</button>
                <button type="button" @click="crop = false" class="button--Accent">Cancel</button>
              </div>
            </div>
          </div>
        </div>

        <div class="tab__Wrapper">
          <ul class="fileItems" v-if="items && items.length > 0">
            <template v-for="item in items">
              <li
                v-if="item.name !== 'IMG_CE81A9CBB6AA-1.jpeg'"
                :key="item.uuid"
                class="fileItem"
                :class="{ 'is-Selectable': selectable || item.type === 'image' }"
              >
                <img class="fileItem__Image" v-if="item.type === 'image'" :src="item.thumbnail_urls.card" alt="" />
                <icon class="fileItem__Icon" :name="`file-${getFileType(item.type)}`" v-else />
                <h3 class="fileItem__Name">{{ item.name }}</h3>
                <input
                  type="text"
                  readonly
                  class="fileItem__Url"
                  :value="item.url"
                  @click="copyToClipboard(item.url)"
                />
                <div class="fileItem__Buttons">
                  <button
                    class="button--Small button--Vertical button--Accent"
                    @click="selectFile(item)"
                    v-if="selectable"
                  >
                    {{ $store.getters.getStringTranslation('select') }}
                  </button>
                  <button
                    v-if="item.type === 'image'"
                    class="button--Small button--Vertical button--AccentTwo"
                    @click="openCrop(item)"
                  >
                    {{ $store.getters.getStringTranslation('cropImage') }}
                  </button>
                  <a
                    :href="item.thumbnail_urls.original"
                    target="_blank"
                    class="button--Small button--Vertical button--AccentTwo buton--DownloadImg"
                    v-if="item.type === 'image'"
                    >{{ $store.getters.getStringTranslation('download') }}</a
                  >
                </div>
              </li>
            </template>
          </ul>

          <div class="error" v-else-if="loading === false">
            <p>{{ $store.getters.getStringTranslation('noContent') }}</p>
          </div>
        </div>
      </div>
      <pagination v-bind="{ searchParams, count }" dispatch="getUploads" />
    </section>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'
import Loader from '@/components/partials/Loader.vue'
import Pagination from '@/components/partials/Pagination.vue'
import CopyToClipboard from '@/components/mixins/CopyToClipboard.js'

export default {
  name: 'Uploads',
  props: {
    selectable: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    defaults: {
      type: Object,
      default() {
        return {
          types: [],
          org_id: this.$store.state.accounts.user.org_id,
          hidden: false,
        }
      },
    },
  },
  mixins: [CopyToClipboard],
  components: {
    Loader,
    Pagination,
  },
  data() {
    return {
      filters: {
        types: ['Doc', 'PDF', 'PPT', 'XLS', 'Audio', 'Video', 'Image'],
        search_query: this.$store.state.uploads.searchParams.search_query,
        order_by: ['Updated', 'Inserted', 'Alphabetical'],
        order_dir: ['DESC', 'ASC'],
      },
      file: {},
      image: '',
      clip: {},
      crop: false,
      updating: false,
      loaded: true,
      photoLibrary: false,
    }
  },
  computed: {
    items() {
      return this.$store.state.uploads.list.media
    },
    count() {
      const count = this.$store.state.uploads.list.counts
      if (count && Object.keys(count).length > 0) return Object.values(count).reduce((a, b) => a + b)

      return 0
    },
    searchParams() {
      const params = this.$store.state.uploads.searchParams
      if (params) return params
      return 0
    },
    loading: {
      set(val) {
        this.$store.dispatch('setUploadsLoading', val)
      },
      get() {
        return this.$store.state.uploads.loading
      },
    },
  },
  mounted() {
    this.filter(this.defaults)
    console.log(this.$store.state.accounts.user.org_id)
  },
  methods: {
    getFileType(type) {
      if (type === 'doc') return 'word'
      if (type === 'xls') return 'excel'
      if (type === 'ppt') return 'powerpoint'
      return type
    },

    filter(obj) {
      obj.org_id = this.$store.state.accounts.user.org_id
      this.$store.dispatch('getUploads', obj).then(
        () => {
          this.loading = false
        },
        (error) => {
          console.error(error)
        }
      )
    },

    selectFile(item) {
      this.$emit('input', item)
    },

    openCrop(item) {
      // Cropper can be tested with this image instead of the ones served from amazon. If crop doesn't work, AWS is most likely blocking CORS. Use this image to test it out instead: this.image = 'https://timtnleeproject.github.io/vuejs-clipper/dawn.jpg'
      this.image = item.thumbnail_urls.original
      this.crop = true
    },

    // Generate cropped image
    generateImage() {
      const canvas = this.$refs.clipper.clip()
      canvas.toBlob((blob) => {
        const file = new File([blob], this.image.substring(this.image.lastIndexOf('/') + 1), {
          type: 'image/jpeg',
          lastModified: Date.now(),
        })
        this.file = file
        this.uploadFile()
        this.crop = false
      }, 'image/jpeg')
    },

    // File upload
    handleChange(event) {
      this.file = event.target.files[0]
      this.uploadFile()
    },

    uploadFile() {
      this.errors = []
      if (this.file) {
        // Create a new FileReader to read file
        const reader = new FileReader()

        reader.onload = () => {
          this.loading = true

          let formData = new FormData()
          formData.append('file', this.file)
          formData.append('org_id', this.$store.state.accounts.user.org_id)
          formData.append('hidden', false)

          HTTP.post(`upload`, formData)
            .then((response) => {
              // Load data, set type to scraper type
              this.loading = false

              // Populate with response
              this.$store.dispatch('addNewUploadItem', response.data)
              this.file = {}
            })
            .catch((e) => {
              this.errors = e.response ? e.response.data : console.error(e)
              this.loading = false
            })
        }
        reader.readAsBinaryString(this.file)
      } else {
        this.errors = 'Something went wrong!'
      }
    },
  },
  watch: {
    'filters.search_query'(value) {
      if (value.length === 0) {
        this.filter({ search_query: this.filters.search_query })
      }
    },
  },
}
</script>
